const authAPIRoutes = {
  signUp: '/api/v1/auth/register',
  loginAdmin: '/api/v1/auth/login',
  resetPassword: '/api/v1/auth/reset-password',
  forgotPassword: '/api/v1/auth/forgot-password',
  verifyOtp: '/api/v1/auth/otp-verification',
  globalAdminDashboard: '/api/v1/subscription/global-admin-web-dashboard',
}

export const apiRoutes = {
  ...authAPIRoutes,
}
